<template>
    <div class="font-size-select">
	    <input-field v-bind="$attrs" min="0" max="500" step="1" v-model.number="localValue"
	                 @input="onInput" @change="onChange" append="px" small type="number" />
    </div>
</template>

<script>
import InputField from "@/components/base/input-field";
export default {
	name: 'FontSizeSelect',
	components: {InputField},
	props: ['value'],
	data: function () {
		return {
			localValue: this.value,
		}
	},
	watch: {
		value(){
			this.updateLocalValue();
		}
	},
	computed: {

	},
	methods: {
		updateLocalValue() {
			let v = (this.value || '10') + 'px';
			if (v.indexOf('px')>=0) {
				this.localValue = parseInt(v.replace('px', ''));
			} else {
				this.localValue = parseInt(v || '8');
			}
		},
		onInput(e) {
			this.$emit('input', e);
		},
		onChange(e) {
			this.$emit('change', e);
		},
	},
	created() {
		this.updateLocalValue();
	}
}
</script>
<style lang="scss">
.font-size-select {
	width: 70px;
	text-transform: none;
}
</style>
